import dpiReveal from '../reveal';

export default {
  init() {
      
  },
  finalize() {
    dpiReveal.init();
  },
};


// WEBPACK FOOTER //
// ./source/scripts/js/routes/Sacraments.js